// extracted by mini-css-extract-plugin
export var quantityInput = "_ne-0";